var map = {
	"./argis-dev.svg": [
		98057,
		57
	],
	"./code-tags.svg": [
		22550,
		550
	],
	"./flutter.svg": [
		10960,
		960
	],
	"./hr.svg": [
		59517,
		517
	],
	"./nodejs.svg": [
		85313,
		313
	],
	"./php.svg": [
		26788,
		788
	],
	"./reactIcon.svg": [
		67570,
		570
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 11435;
module.exports = webpackAsyncContext;